var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#FFCDCD",
    stroke: "#F15B5B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75737 5.70698C6.1479 5.31646 6.78683 5.32223 7.18448 5.71988L14.2298 12.7652C14.6274 13.1628 14.6332 13.8017 14.2427 14.1923C13.8521 14.5828 13.2132 14.577 12.8155 14.1794L5.77026 7.13409C5.37262 6.73645 5.36685 6.09751 5.75737 5.70698Z",
    fill: "#F15B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7574 14.1922C5.36688 13.8017 5.37265 13.1628 5.77029 12.7651L12.8156 5.71983C13.2132 5.32218 13.8522 5.31641 14.2427 5.70693C14.6332 6.09746 14.6274 6.7364 14.2298 7.13404L7.18451 14.1793C6.78686 14.577 6.14792 14.5827 5.7574 14.1922Z",
    fill: "#F15B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCancel);
export default __webpack_public_path__ + "static/media/circle-cancel.3b0583045a3992ba1c18efd9f265f0a0.svg";
export { ForwardRef as ReactComponent };